import {
  getPercentageValue,
  pressTimeGrouping,
  sortTimeListFunc,
} from '@op/utils';
import _ from 'lodash-es';

function dealwithSingleChannelSplite(
  list: Array<{ [key: string]: any }>,
  totalList: Array<any>,
  metrics: Array<string>,
) {
  const totalMap = totalList[0];

  return list.map(item => {
    return metrics.reduce((pre, key) => {
      const value = item[key] || 0;
      const total = totalMap[key] || 0;

      return { ...pre, [key + '_share']: getPercentageValue(value, total, 4) };
    }, item);
  });
}

function dealwithChannelDateSplite(
  list: Array<any>,
  dateType: string,
  metrics: Array<string>,
) {
  const format = dateType === 'hourly' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
  const data: any = pressTimeGrouping(list, format);
  const keys = Object.keys(data);
  const result = keys
    .map(key => {
      const element = data[key];
      const total: { [key: string]: number } = {};
      element.map((item: any) => {
        metrics.map(key => {
          if (!_.has(total, key)) total[key] = 0;
          total[key] += item[key] || 0;
        });
      });
      return dealwithSingleChannelSplite(element, [total], metrics);
    })
    .flat(2);
  result.sort(sortTimeListFunc('time', 'desc'));
  return result;
}

export function donwloadVideoDealwith(
  data: any,
  params: { metrics: string[]; group_bys: string[]; date_type: string },
) {
  const totalList = data?.total_list || [];
  const list = data?.list || [];
  const { metrics = [], group_bys = [], date_type } = params || {};

  if (group_bys?.length === 0) {
    return totalList;
  }

  if (group_bys?.length === 1 && group_bys?.[0] === 'time') {
    list.sort(sortTimeListFunc('time', 'desc'));
    return list;
  }

  if (group_bys?.length === 1 && group_bys?.[0] === 'channel') {
    return dealwithSingleChannelSplite(list, totalList, metrics);
  }

  return dealwithChannelDateSplite(list, date_type, metrics);
}

// 8 Ball Pool 特殊版本 ID
export const EIGHTBALL_EDITION_ID = 'u0ea54cd6abaed768bad32cc70b4f6695';

/**
 * 判断是否为特殊版本（8 Ball Pool）
 */
export function isSpecialEdition(gameInfo: any): boolean {
  return gameInfo?.edition_unified_id === EIGHTBALL_EDITION_ID;
}

export function dealwith8BallParams(params: any) {
  const data = { ...params };
  // 针对8 ball 这个游戏，只展示miniclip的视频
  if (data.edition_unified_id === EIGHTBALL_EDITION_ID) {
    data.show_only_game_related_feeds = true;
  }
  return data;
}
const sellingPointsMap: { [key: string]: { text: string; textCn: string } } = {
  'beast mode': { text: 'Beast Mode', textCn: '野兽模式' },
  combat: { text: 'Combat', textCn: '战斗' },
  volatiles: { text: 'Volatiles', textCn: '夜魔' },
  chimera: { text: 'Chimera', textCn: '奇美拉' },
  weapons: { text: 'Weapons', textCn: '武器' },
  'night experience': { text: 'Night Experience', textCn: '夜晚体验' },
  gore: { text: 'Gore', textCn: '血腥暴力' },
  vehicle: { text: 'Vehicle', textCn: '汽车载具' },
  'co-op': { text: 'Co-op', textCn: '合作模式' },
  parkour: { text: 'Parkour', textCn: '跑酷' },
  others: { text: 'Others', textCn: '其他' },
};

const videoCategoriesMap: { [key: string]: { text: string; textCn: string } } =
  {
    "let's play": { text: "Let's Play", textCn: '实况解说' },
    reactions: { text: 'Reactions', textCn: '反应视频' },
    'guides&tutorials': { text: 'Guides&Tutorials', textCn: '指南教程' },
    'reviews&analysis': { text: 'Reviews&Analysis', textCn: '评测分析' },
    'lore&story': { text: 'Lore&Story', textCn: '剧情故事' },
    'highlights&montages': { text: 'Highlights&Montages', textCn: '精彩集锦' },
    'news&updates': { text: 'News&Updates', textCn: '新闻更新' },
    'community&creations': { text: 'Community&Creations', textCn: '社区创作' },
    'memes&humor': { text: 'Memes&Humor', textCn: '幽默玩梗' },
    others: { text: 'Others', textCn: '其他' },
  };

function commonTranslate(value: string, isCategory: boolean, isEn: boolean) {
  const key = value.toLocaleLowerCase();
  const valueKey = isEn ? 'text' : 'textCn';

  const map = isCategory ? videoCategoriesMap : sellingPointsMap;

  return map[key]?.[valueKey] || value;
}

export function translateVideoList(
  {
    records,
    gptSubTitleSummaryList,
  }: { records: any; gptSubTitleSummaryList: any },
  isCategory: boolean,
  isEn: boolean,
) {
  const key = records.comment_uin;
  const dataKey = isCategory ? 'video_categories' : 'selling_points';
  const list = gptSubTitleSummaryList?.[key]?.[dataKey] || [];

  if (list.length === 0) {
    return '-';
  }

  return list
    .map((item: string) => commonTranslate(item, isCategory, isEn))
    .join(', ');
}

export const formatAITagsFilterValue = (oneLevel: string[]) => {
  return oneLevel?.map(each => {
    return { t1: each, t2: [] };
  });
};
